<template>
	<div>
		<page-loader/>
		<component :is="currentView"></component>
	</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import PageLoader from '@/components/page-loader/page-loader.vue';
  import MarketAnalysisPrinting from '@/modules/neodash/containers/market-analysis/market-analysis-printing';
  import RapPrinting from '@/modules/neodash/containers/rap/rap-printing';

  import RetailBillingPrinting from '@/modules/neodash/containers/retail-billing/retail-billing-printing';
  import MarketBreakDownPrinting from '@/modules/neodash/containers/market-break-down/market-break-down-printing';

  import {PRINT_DISABLE_PRINT_MODE, PRINT_ENABLE_PRINT_MODE, PRINT_GET_PARAMS} from '@/store/modules/print/types';
  import {DISABLE_LOADING, ENABLE_LOADING, GET_LOADING} from '@/store/types';

  export default {
    data() {
      return {
        timeout: null
      };
    },

    computed: {
      ...mapGetters({
        isLoading: GET_LOADING,
        params: PRINT_GET_PARAMS
      }),
      currentView() {
        return `${this.params.reportName}-printing`;
      }
    },

    created() {
      this.$store.dispatch(PRINT_ENABLE_PRINT_MODE);
      this.$store.dispatch(ENABLE_LOADING);
      setTimeout(() => {
        this.$store.dispatch(DISABLE_LOADING);
      }, 5000);
      $('<style>html, body {background: #fff !important;}</style>').appendTo(document.head);
    },

    destroyed() {
      this.$store.dispatch(PRINT_DISABLE_PRINT_MODE);
    },

    watch: {
      isLoading(val) {
        if (!val) {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }

          this.timeout = setTimeout(() => {
            console.log('LOAD COMPLETED');
            if (this.params.dialog) {
              window.focus();
              window.print();
            }
          }, 5000);
        }
      }
    },

    components: {
      PageLoader,
      RapPrinting,
      MarketAnalysisPrinting,
      RetailBillingPrinting,
      MarketBreakDownPrinting
    }
  };
</script>
